<template>
  <div ref="chart" class="e-chart" :style="{ height }"></div>
</template>

<script>
// Wrapper genérico do Apache ECharts 5 (tree-shaken + lazy).
// A biblioteca só é baixada quando o primeiro EChart monta na tela
// (chunk separado "echarts") — não pesa no carregamento do app.
// Uso: <e-chart :option="option" height="300px" />
let echartsPromise = null;

function loadEcharts() {
  if (!echartsPromise) {
    // echarts-setup.js tem os imports estáticos (tree-shaking real);
    // o import() dinâmico daqui é o que gera o chunk separado.
    echartsPromise = import(/* webpackChunkName: "echarts" */ "./echarts-setup")
      .then((module) => module.default);
  }
  return echartsPromise;
}

export default {
  name: "EChart",
  props: {
    option: { type: Object, required: true },
    height: { type: String, default: "300px" },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    option: {
      deep: true,
      handler() {
        if (this.chart) {
          this.chart.setOption(this.option, true);
        }
      },
    },
  },
  methods: {
    resize() {
      if (this.chart) {
        this.chart.resize();
      }
    },
  },
  mounted() {
    const vm = this;
    loadEcharts().then((echarts) => {
      if (!vm.$refs.chart) {
        return; // componente já foi destruído
      }
      vm.chart = echarts.init(vm.$refs.chart);
      vm.chart.setOption(vm.option, true);
      vm.chart.on("click", (params) => vm.$emit("chart-click", params));
      vm.chart.on("mouseover", (params) => vm.$emit("chart-mouseover", params));
      vm.chart.on("mouseout", (params) => vm.$emit("chart-mouseout", params));
      window.addEventListener("resize", vm.resize);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resize);
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
};
</script>

<style>
.e-chart {
  width: 100%;
}
</style>
